import React from 'react'
import { get } from 'lodash'
import Client from 'components/Client'
import getCurrentUserQuery from 'graphql/user/getCurrentUser.gql'
import { logException } from 'lib/errors'

export const NETTIX_USER_TYPE = {
    SELLER: 'seller',
    DEALER: 'dealer',
}

export const PGWStatus = {
    PENDING: 'PENDING',
    ACTIVE: 'ACTIVE',
    WAITING_APPROVAL: 'WAITING_APPROVAL',
    WAITING_REVIEW: 'WAITING_REVIEW',
    BLOCKED: 'BLOCKED',
    CLOSED: 'CLOSED',
}

// Store helper functions for currentUser

export const getCurrentUser = () => {
    // This...
    //
    // graphql(getCurrentUserQuery, {
    //     name: 'currentUser',
    //     options: {
    //         fetchPolicy: 'cache-only',
    //     },
    // })
    //
    // ...causes unnecessary renders with cache-first (1 extra render) and cache-only (2 extra renders),
    // so we read the currentUser directly from cache instead since currentUser is so heavily used across the app.
    //
    // Not sure why this happens as it should be fixed already:
    // https://github.com/apollographql/react-apollo/issues/2441
    let data = null
    try {
        data = Client.cache.readQuery({ query: getCurrentUserQuery })
    } catch (e) {
        const message = get(e, 'message', '')
        if (
            message === 'Can\'t find field \'me\' on ROOT_QUERY object' ||
            message.indexOf('Invariant Violation: 5') === 0
        ) {
            // expected exceptions requires no logging
        } else {
            logException(e)
        }
    }

    return data || { me: null }
}

/**
 * HoC to get currentUser from cache.
 */
export const graphqlCurrentUserCached = (WrappedComponent) => {
    return class CurrentUserHoC extends React.Component {
        render () {
            const currentUser = getCurrentUser()
            return <WrappedComponent {...this.props} currentUser={currentUser} />
        }
    }
}

export const isLoggedIn = (currentUser) => {
    return currentUser && !!currentUser.me
}

/**
 * Is user boarded to maskuturva.
 * @param currentUser
 */
export const isBoarded = (currentUser) => {
    return !!currentUser.me.pgwStatus
}

export const isAdmin = (currentUser) => {
    return currentUser.me && currentUser.me.isAdmin
}

export const isDealer = (currentUser) => {
    return currentUser.me && currentUser.me.userType === NETTIX_USER_TYPE.DEALER
}

export const getBosUserRole = (currentUser, bos) => {
    return isAdmin(currentUser) ? 'ADMIN' : bos.currentUserRole
}

export const isIdentified = (currentUser) => {
    return !!get(currentUser, 'me.user.lastIdentification', null)
}

export const isPgwActive = (currentUser) => {
    return currentUser?.me?.pgwStatus === PGWStatus.ACTIVE
}

export const isPgwExpired = (currentUser) => {
    return currentUser?.me?.pgwStatus === PGWStatus.CLOSED
}

export const isPgwUnfinished = (currentUser) => {
    const status = currentUser?.me?.pgwStatus

    return !status || [
        PGWStatus.PENDING,
        PGWStatus.WAITING_APPROVAL,
        PGWStatus.WAITING_REVIEW,
        PGWStatus.BLOCKED,
    ].includes(status)
}

export const pgwStatusesToDisplayContinueIdentification = (currentUser) => {
    const status = currentUser?.me?.pgwStatus

    return !status || [
        PGWStatus.PENDING,
        PGWStatus.WAITING_APPROVAL,
        PGWStatus.WAITING_REVIEW,
    ].includes(status)
}
